import { FaEdit, FaMinusCircle } from 'react-icons/fa'
import { Table, TableContainer, Tag, Td, Th, Tr } from './styles'

export function IdrsTable({ idrs, circuits, onEdit, onRemove }) {
  if (idrs.length === 0) return <p>Nenhum IDR cadastrado. Circuitos sem IDR são permitidos.</p>

  return (
    <TableContainer>
      <Table style={{ marginTop: '12px' }}>
        <thead>
          <Tr>
            <Th>IDR</Th>
            <Th>Nome</Th>
            <Th>Circuitos protegidos</Th>
            <Th>Ações</Th>
          </Tr>
        </thead>
        <tbody>
          {idrs.map((idr) => {
            const linked = circuits.filter((circuit) => circuit.idrId === idr.id)

            return (
              <Tr key={idr.id}>
                <Td>{idr.id}</Td>
                <Td>{idr.name}</Td>
                <Td>
                  {linked.length > 0 ? linked.map((circuit) => circuit.id).join(', ') : <Tag $warn>sem circuitos</Tag>}
                  {linked.length > 0 && linked.length === circuits.length && circuits.length > 1 && (
                    <>
                      {' '}
                      <Tag>geral</Tag>
                    </>
                  )}
                </Td>
                <Td style={{ whiteSpace: 'nowrap' }}>
                  <button type="button" title="Editar IDR" aria-label="Editar IDR" onClick={() => onEdit(idr)}>
                    <FaEdit />
                  </button>{' '}
                  <button type="button" title="Remover IDR" aria-label="Remover IDR" onClick={() => onRemove(idr.id)}>
                    <FaMinusCircle />
                  </button>
                </Td>
              </Tr>
            )
          })}
        </tbody>
      </Table>
    </TableContainer>
  )
}
